import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faCertificate } from '@fortawesome/free-solid-svg-icons';

export default function CertCard({ name, img, issued, date, verifyUrl, category }) {
  const targetLink = verifyUrl || img;

  return (
    <div
      className="flex flex-col justify-between rounded-2xl bg-dark-200/50 border border-zinc-800/90 hover:border-teal-500/50 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-teal-500/5 group p-5"
    >
      <div>
        {/* Certificate Image Frame */}
        <a
          href={targetLink}
          target="_blank"
          rel="noreferrer"
          className="block relative w-full h-48 rounded-xl bg-dark-300/80 border border-zinc-700/50 p-3 overflow-hidden group-hover:border-teal-500/40 transition-colors"
        >
          <img
            src={img}
            alt={name}
            className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
          />
          <div className="absolute top-2.5 right-2.5 w-7 h-7 rounded-lg bg-dark-400/90 border border-zinc-700 flex items-center justify-center text-gray-300 group-hover:text-teal-300 transition-colors">
            <FontAwesomeIcon icon={faExternalLinkAlt} className="text-xs" />
          </div>
        </a>

        {/* Issuer & Date Badges */}
        <div className="flex items-center justify-between gap-2 mt-4 mb-2">
          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold bg-teal-500/10 text-teal-300 border border-teal-500/20">
            <FontAwesomeIcon icon={faCertificate} className="text-[10px]" />
            <span>{issued}</span>
          </span>
          <span className="text-xs text-gray-400 font-medium">{date}</span>
        </div>

        {/* Certificate Name */}
        <h3 className="font-bold text-base sm:text-lg text-white group-hover:text-teal-300 transition-colors line-clamp-2 mt-1">
          {name}
        </h3>
      </div>

      {/* Verify / View CTA Button */}
      <div className="pt-4 mt-3 border-t border-zinc-800/80">
        <a
          href={targetLink}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-xs font-semibold text-teal-400 hover:text-teal-300 transition-colors"
        >
          <span>{verifyUrl ? "Verify Credential on Credly" : "View Certificate"}</span>
          <FontAwesomeIcon icon={faExternalLinkAlt} className="text-[10px]" />
        </a>
      </div>
    </div>
  );
}
